var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1707,
    height: 908,
    viewBox: "0 0 1707 908",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_546_42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.145 -5.45484C377.5 4.86245 423.487 51.5666 433.56 73.6289L495.284 188.263C495.653 188.949 496.177 189.538 496.813 189.985L643.457 292.951C644.532 293.706 645.861 294.007 647.156 293.79L777.444 271.951C778.619 271.754 779.825 271.983 780.846 272.596L908.48 349.289C909.25 349.752 909.881 350.413 910.307 351.204L1022.81 560.149C1023.31 561.068 1024.08 561.809 1025.01 562.268L1266.78 680.795C1267.89 681.339 1269.16 681.452 1270.35 681.114L1443.95 631.73C1445.44 631.307 1447.04 631.595 1448.29 632.512L1622.93 761.075C1623.93 761.81 1624.62 762.89 1624.86 764.105L1668.64 979.268C1668.94 980.763 1668.55 982.315 1667.57 983.482L1523.38 1155",
    stroke: "#A5A5A5",
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1621.1,
    cy: 764.868,
    r: 39.5,
    transform: "rotate(-172.939 1621.1 764.868)",
    stroke: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1621.1,
    cy: 764.868,
    r: 19.75,
    transform: "rotate(-172.939 1621.1 764.868)",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1621.1,
    cy: 764.868,
    r: 19.75,
    transform: "rotate(-172.939 1621.1 764.868)",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1621.1,
    cy: 764.868,
    r: 19.75,
    transform: "rotate(-172.939 1621.1 764.868)",
    stroke: "#A5A5A5",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1621.1,
    cy: 764.868,
    r: 9.875,
    transform: "rotate(-172.939 1621.1 764.868)",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1621.1,
    cy: 764.868,
    r: 9.875,
    transform: "rotate(-172.939 1621.1 764.868)",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1621.1,
    cy: 764.868,
    r: 9.875,
    transform: "rotate(-172.939 1621.1 764.868)",
    stroke: "#A5A5A5",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1442.82,
    cy: 637.523,
    r: 39.5,
    transform: "rotate(-172.939 1442.82 637.523)",
    stroke: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1442.82,
    cy: 637.523,
    r: 19.75,
    transform: "rotate(-172.939 1442.82 637.523)",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1442.82,
    cy: 637.523,
    r: 19.75,
    transform: "rotate(-172.939 1442.82 637.523)",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1442.82,
    cy: 637.523,
    r: 19.75,
    transform: "rotate(-172.939 1442.82 637.523)",
    stroke: "#A5A5A5",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1442.82,
    cy: 637.523,
    r: 9.875,
    transform: "rotate(-172.939 1442.82 637.523)",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1442.82,
    cy: 637.523,
    r: 9.875,
    transform: "rotate(-172.939 1442.82 637.523)",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1442.82,
    cy: 637.523,
    r: 9.875,
    transform: "rotate(-172.939 1442.82 637.523)",
    stroke: "#A5A5A5",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1019.91,
    cy: 550.339,
    r: 39.5,
    transform: "rotate(-172.939 1019.91 550.339)",
    stroke: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1019.91,
    cy: 550.339,
    r: 19.75,
    transform: "rotate(-172.939 1019.91 550.339)",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1019.91,
    cy: 550.339,
    r: 19.75,
    transform: "rotate(-172.939 1019.91 550.339)",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1019.91,
    cy: 550.339,
    r: 19.75,
    transform: "rotate(-172.939 1019.91 550.339)",
    stroke: "#A5A5A5",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1019.91,
    cy: 550.339,
    r: 9.875,
    transform: "rotate(-172.939 1019.91 550.339)",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1019.91,
    cy: 550.339,
    r: 9.875,
    transform: "rotate(-172.939 1019.91 550.339)",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1019.91,
    cy: 550.339,
    r: 9.875,
    transform: "rotate(-172.939 1019.91 550.339)",
    stroke: "#A5A5A5",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.208,
    cy: 190.231,
    r: 39.5,
    transform: "rotate(-172.939 496.208 190.231)",
    stroke: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.208,
    cy: 190.231,
    r: 19.75,
    transform: "rotate(-172.939 496.208 190.231)",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.208,
    cy: 190.231,
    r: 19.75,
    transform: "rotate(-172.939 496.208 190.231)",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.208,
    cy: 190.231,
    r: 19.75,
    transform: "rotate(-172.939 496.208 190.231)",
    stroke: "#A5A5A5",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.208,
    cy: 190.23,
    r: 9.875,
    transform: "rotate(-172.939 496.208 190.23)",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.208,
    cy: 190.23,
    r: 9.875,
    transform: "rotate(-172.939 496.208 190.23)",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.208,
    cy: 190.23,
    r: 9.875,
    transform: "rotate(-172.939 496.208 190.23)",
    stroke: "#A5A5A5",
    strokeWidth: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_546_42"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1707,
    height: 908,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/mission.b750bfc57035dcc345b28dcd19b99934.svg";
export { ForwardRef as ReactComponent };